/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

export const Divider = styled.div`
  border-bottom: 1px solid ${theme.color.border.border01};
`;
